
































import { Vue, Component } from 'vue-property-decorator';
import EmojiPicker from 'vue-emoji-picker';
import Icon from '@/components/Icon.vue';
import Button from '@/components/Button.vue';

@Component({
  components: {
    EmojiPicker,
    Icon,
    Button,
  },
})
export default class ChatEmojis extends Vue {
  search: string = '';
  frequentlyUsed: string = 'Frequently used';

  showCategory(category: string): boolean {
    return category !== this.frequentlyUsed;
  }

  public select(emoji: string): void {
    this.$emit('select', emoji);
  }
}
